import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChange
} from "@angular/core";
import { ViewEncapsulation } from "@angular/core";
import { Color, COLOR_MAP } from "src/app/enum/color";
import { SupplierProductAssortmentStatus, Status } from "src/app/enum";
import { environment } from "src/environments/environment";

@Component({
  selector: "image-popover",
  templateUrl: "./image-popover.component.html",
  styleUrls: ["./image-popover.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class ImagePopoverComponent implements OnChanges {
  public COLOR_MAP = COLOR_MAP;

  @Input() public enum: any;
  @Input() public defaultImageUrlId: string = null;

  public fallbackImage = "/assets/img/icons/no-content/no-image.svg";
  public thumbnailFallbackImage =
    "/assets/img/icons/no-content/no-image-small.svg";

  public imageSource: string;
  public thumbnailSource: string;
  public tooltipContentVisible = false;
  public popperTrigger = "hover";
  public popperHideOnMouseLeave = true;
  public popperShowOnStart = false;

  public get localThumbnail(): boolean {
    return this.thumbnailSource === this.thumbnailFallbackImage;
  }

  public get localImage(): boolean {
    return this.imageSource === this.fallbackImage;
  }

  @Input() public thumbnail: string;
  @Input() public thumbnailBase64: boolean = false;
  @Input() public thumbnailContentType: string;

  @Input() public image: string;
  @Input() public imageBase64: boolean = false;
  @Input() public imageContentType: string;

  @Input() public imageUrl: string;
  @Input() public thumbnailUrl: string;

  @Input() public status: number;
  @Input() public statusText: any;
  @Input() public color: Color;
  @Input() public description: string;
  @Input() public position: string = "right";
  @Input() public delay: number = 300;
  @Input() public appendTo: string = "app-root";
  @Input() public type: string = ImagePopoverType.Product;
  @Input() public popperPositionFixed = true;
  @Input() public imageFit = "contain";

  // @Input() public isActive: boolean = undefined;
  // @Input() public isInactive: boolean = undefined;
  // @Input() public isPending: boolean = undefined;
  @Input() public isActiveBottom: boolean = false;
  @Input() public isImageIllustrative: boolean = false;

  public errors = {
    thumbnail: false,
    image: false
  };

  public loading = {
    thumbnail: true,
    image: true
  }

  public onImgError(type: string) {
    this[`${type}Source`]= this[`${type}FallbackImage`];
    this.errors[type] = true;
    this.loading[type] = false;
  }

  public onImgLoad(type:string) {
    this.errors[type] = false;
    this.loading[type] = false;
  }

  public get isActive() {

    switch (this.type) {
      case ImagePopoverType.Product:
        return this.status == SupplierProductAssortmentStatus.Active;
      case ImagePopoverType.Regular:
      default:
        return this.status == Status.Active;
    }
  }

  public get isInactive() {

    switch (this.type) {
      case ImagePopoverType.Product:
        return this.status == SupplierProductAssortmentStatus.EndOfLife || this.status == SupplierProductAssortmentStatus.Inactive;
      case ImagePopoverType.Regular:
      default:
        return this.status == Status.Disabled;
    }
  }

  public get isPending() {
    switch (this.type) {
      case ImagePopoverType.Product:
        return this.status == SupplierProductAssortmentStatus.SchemeStartsTomorrow;
      default:
        return false;
    }
  }

  public get statusEnum() {

    if (this.enum) {
      return this.enum;
    }

    switch (this.type) {
      case ImagePopoverType.Product:
        return SupplierProductAssortmentStatus;
      case ImagePopoverType.Regular:
      default:
        return Status;
    }
  }

  public get statusColor() {
    if (this.color === undefined) {
      return null;
    }
    return COLOR_MAP[this.color] || "var(--light-pink)";
  }

  public ngOnChanges() {

    let imageSource: string;
    let thumbnailSource: string;
    
    if (this.thumbnailUrl) { 
      thumbnailSource = `${environment.apiUrl}api/${this.thumbnailUrl}`;
    } else {
      thumbnailSource = this.defaultImageUrlId ? `${environment.apiUrl}api/products/${this.defaultImageUrlId}/images/thumbnailMedium` : this.thumbnail;
      if (thumbnailSource && this.thumbnailBase64) {
        thumbnailSource = `data:${this.thumbnailContentType};base64,${thumbnailSource}`;
      }
    }

    if (this.imageUrl) { 
      imageSource = `${environment.apiUrl}api/${this.imageUrl}`;
    } else {
      imageSource = this.defaultImageUrlId ? `${environment.apiUrl}api/products/${this.defaultImageUrlId}/images` : this.image;
      if (imageSource && this.imageBase64) {
        imageSource = `data:${this.imageContentType};base64,${imageSource}`;
      }
    }

    this.thumbnailSource =
      thumbnailSource || imageSource || this.thumbnailFallbackImage;
    this.imageSource = imageSource || this.fallbackImage;

    // this.getStatusEnum();
    // this.getIsActive();
    // this.getIsInactive();
    // this.getIsPending();
  }

  public get hasStatus() {
    return (
      (this.status !== undefined && this.status !== null) ||
      (this.statusText ? true : false)
    );
  }

  public onShown() {
    this.tooltipContentVisible = true;
  }

  public preventPropagation() {
    event.stopImmediatePropagation();
  }
}

export enum ImagePopoverType {
  Regular = "regular",
  Product = "product"
}
